import MessageBox from '../message-box/message-box';
import HintIcon from '../hint-icon/hint-icon';
import React, { useEffect } from 'react';
import FullSizeContainer from '../containers/full-size/full-size-container';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loading from '../loading/loading';


export default function AccountEdit() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [totalSeats, setTotalSeats] = React.useState(0);
  const [expirationDate, setExpirationDate] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [accountName, setAccountName] = React.useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const account_id = searchParams.get("account_id");
    if (!account_id) {
      navigate("/login")
    }

    const result = await fetch(
      process.env.REACT_APP_FACES_API_BASE + `/accounts?account_id=${account_id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('facesIDToken'),
        },
        body: JSON.stringify({
          total_seats: Number(totalSeats),
          account_renewal_date: expirationDate,
        }),
      }
    );

    if (!result.ok) {
      alert("Failed to edit account: " + result.statusText);
      setLoading(false);
    }

    navigate("/menu/faces?success=true")
  }

  useEffect(() => {
    (async () => {
      try {
        const account_id = searchParams.get("account_id");
        if (!account_id) {
          navigate("/login")
        }
        const res = await fetch(process.env.REACT_APP_FACES_API_BASE + `/accounts?account_id=${account_id}`, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('facesIDToken'),
            "content-type": "application/json",
          }
        })

        if(!res.ok) {
          const text = await res.json();
          alert(text.error)
          navigate("/login")
          return
        }

        const j = await res.json()
        console.log(j.account_renewal_date)
        setExpirationDate(j.account_renewal_date)
        setTotalSeats(j.total_seats)
        setAccountName(j.account_name)
      } catch (e) {
        console.log(e)
        alert(e)
        navigate("/login")
      } finally {
        setLoading(false);
      }
    })()
  }, [])

  if(loading) {
    return <Loading />
  }

  return (
    <FullSizeContainer title={`EDITING ${accountName}`} prevURL="/menu/faces">
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          marginBottom: '2rem',
        }}
      >
        <h2 style={{ alignSelf: 'flex-start', margin: '2rem 0' }}>
          EDIT ACCOUNT
        </h2>
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <label style={{ flex: 1 }}>
              <h3 className="flex-row-center">
                TOTAL SEATS:
                <HintIcon hint="The total number of seats available for this account. Each seat corresponds to one concurrent use of the FACES™ application." />
              </h3>
              <input
                type="number"
                name="totalSeats"
                value={totalSeats}
                onChange={(e) => setTotalSeats(Number(e.target.value))}
                required
                min="1"
                style={{ width: '100%', marginTop: 4 }}
              />
            </label>
            <label style={{ flex: 1 }}>
              <h3 className="flex-row-center">
                EXPIRATION DATE:
                <HintIcon hint="The date when the account will expire. Users will not have access to this account after then." />
              </h3>
              <input
                type="date"
                name="expirationDate"
                value={expirationDate}
                onChange={(e) => setExpirationDate(e.target.value)}
                required
                min={new Date().toISOString().split('T')[0]}
                style={{ width: '100%', marginTop: 4 }}
              />
            </label>
          </div>

          <button type="submit" className="button" style={{ marginBottom: 2 }}>
            <b>SAVE CHANGES</b>
          </button>
        </form>
      </div>
    </FullSizeContainer>
  )
}